module.exports = __webpack_public_path__ + "img/banner-main-web-01-en.eaeccc62.png";